import { add, startOfDay, startOfToday, format, formatISO, parseISO, set as setTime, differenceInMinutes} from 'date-fns';
import Users from '../api/Users';
import Events from '../api/Events';
import Pos from '../api/Pos';

//these utils can be in regards to events in any capactiy and start cutting down on some repetition to be consistent


/**
 * @param {*} block 
 * @returns 
 * service blocks are saved with a time (so we have the start) and duration.  
 * The end time needs to be convereted and/or extracted
 */
export const calculateEndTime=(block)=>{
    let hours = Math.floor(block.duration/60)
    let remainingMinutes = block.duration%60;
    let startHours=block.start_time.substr(0,2);
    let startMinutes=block.start_time.substr(3,2);
    let endHours = +hours + +startHours;
    let endMinutes = +remainingMinutes + +startMinutes;
    if(endMinutes.toString().length===1) endMinutes = "0" + endMinutes;
    let endTime = `${endHours}:${endMinutes}:000`
    if(endHours > 24) endTime="24:00:00"
    return endTime
}

/**
 * @param {*} time 
 * @param {*} date 
 * @returns 
 * takes a time and a date and returns a date object with that time on that date
 */
export const timesToDates=(time, date)=>{
    let splitTime = time.split(':');
    let hours = +splitTime[0];
    let minutes = +splitTime[1];
    let newDate= add(startOfDay(date), {hours: hours, minutes: minutes})
    return newDate;
}

/**
 * @param {*} services 
 * @returns 
 * takes services and applies an event type data to them so they can be used alongside them in this like calendars, displays, etc
 */
export const eventDetailsToServices=(services)=>{
    let tempEvents=[];
    services.forEach((service)=>{
        service.blocks.forEach((block)=>{
        let endTime = calculateEndTime(block)
        block={
            start_date: service.start_date,
            end_date: service.end_date,
            name: service.name,
            days_of_week:block.day_of_week,
            startTime: timesToDates(block.start_time, new Date()),
            endTime: timesToDates(endTime, new Date()),
            duration: block.duration,
        }
        tempEvents.push(block)
        });
    });
    return tempEvents;
}

/**
 * @param {*} combinedDatesEvents 
 * @returns 
 */
export const sortTimes=(events)=>{
    if(events.length > 0){
        let eventsCopy = [...events]
        for(let i =0; i < eventsCopy.length; i++){
            let newEvents = eventsCopy[i].events.sort((a,b)=>{
                if(a.start_datetime > b.start_datetime) return 1
                if(a.start_datetime < b.start_datetime) return -1
                else return 0
            })
            events[i].events = newEvents
            let newServices = eventsCopy[i].services.sort((a,b)=> {
                if(a.startTime > b.startTime) return 1
                if(a.startTime < b.startTime) return -1
                return 0
            })
            events[i].services = newServices
        }
        return eventsCopy
    }
}

/** 
 * 
 * We have quote a few places where numbers are used and need to be date strings 
 * */
export const convertNumeralToDay=(num)=>{
        switch(num){
            case 0: 
                return 'Sunday';
            case 1:
                return 'Monday';
            case 2:
                return 'Tuesday';
            case 3:
                return 'Wednesday';
            case 4:
                return 'Thursday';
            case 5:
                return 'Friday';
            case 6:
                return 'Saturday';
            default:
                break;
        }
    }


/**
 * Convert min_age and max_age to a statement (i.e - "Participant must be between x and y age")  
 * @param {*} min  - the minimum age  
 * @param {*} max   - the maximum age  
 * @param {string} length - can be "short", "medium", or "long".  Short will be "X - Y" (works best with a label indicating it's ages), "medium" will be "up to {blank years old} to participate" "long" will be "Participant must be {blank} years old to register"
 */
export const ageRangeToStatement=(min, max, length="medium")=>{
    let statement;
    switch(length){
        case "short":
            if(min && !max) statement = `${min}+`
            else if(!min && max) statement = `Up to ${max}`
            else if(min && max) statement = `${min} to ${max}`
            break;
        case "medium":
            if(min && !max) statement = `Must be at least ${min} years old`
            else if(!min && max) statement = `Must be ${max} years old or younger`
            else if(min && max) statement = `Must be between ${min} and ${max} years old`
            break;
        case "long":
        default:
            if(min && !max) statement = `Participant must be at least ${min} years old to register`
            else if(!min && max) statement = `Participant must be ${max} years old or younger to register`  
            else if(min && max) statement = `Participant must be between ${min} and ${max} years old to register`
            break
        
    }
    return statement;
}


/**
 * Allows for the startdate/end date to both be put in and formatted, but will omit the second if they match
 * 
 * @param {date} startDate 
 * @param {date} endDate 
 * @param {string} dateFormat 
 * @returns 
 */
export const datesFormatter = (startDate, endDate, dateFormat="ccc MM/dd/yyyy") => {
    if(startDate && endDate){
        let startFormatted = format(new Date(startDate), dateFormat);
        let endFormatted = format(new Date(endDate), dateFormat);

        if(startFormatted === endFormatted) return startFormatted;
        else return startFormatted + " - " + endFormatted;
    }else if(startDate && !endDate){
        return format(new Date(startDate), dateFormat);
    }else if(!startDate && endDate){
        return format(new Date(endDate), dateFormat);
    }else{
        return null;
    }
}

export const findMinMax = (dateTimes) => {
    let minHour = null;
    let maxHour = null;
    dateTimes.forEach((block, block_index) => {
        let start_hour = parseInt(block.timeslots[0].start_time.split(":")[0]);
        let end_time = block.timeslots[block.timeslots.length-1].end_time.split(":")
        let end_hour = parseInt(end_time[0]) + (parseInt(end_time[1])===0 ? 0 : 1);
        if (minHour===null || start_hour < minHour) minHour = start_hour;
        if (maxHour===null || end_hour > maxHour) maxHour = end_hour;
    });
    return {
        min: minHour,
        max: maxHour
    }
}

/** @param {boolean} includePast - staff late bookings look at days that already happened */
export const findDateRanges = (blocks, rangeStart, rangeEnd, minMax, includePast=false)=>{
    let day = new Date(rangeStart);
    let list = [];
    while (day <= new Date(rangeEnd)) {
        // does this date exist in the service blocks? use for loop so we can break out of it
        for (let i=0; i<blocks.length; i++) {
            // don't include events that happened in the past
            if (blocks[i].day_of_week===day.getDay() && (includePast || day>=startOfToday())) {
                // if there is a block for that day of the week add to the search params
                // day should already be 00:00:00 but just in case let's set these to 0 so we never have problems with the search range
                let start = setTime(day, { hours: minMax.min, minutes: 0, seconds: 0 });
                let end = setTime(day, { hours: minMax.max, minutes: 0, seconds: 0 });
                list.push({
                    start_datetime: formatISO(start),
                    end_datetime: formatISO(end),
                });
                // we don't need to check the other blocks for that same day
                break;
            }
        }
        day.setDate(day.getDate()+1);
    }
    return list;
}

export const adjustEventConflictData = (location, events) => {
    if (!events || events.length===0) return null;
    let found = events.find(ev => ev.location_id===location);
    return (found!=='undefined') ? found.datetime_ranges : null;
}

export const adaptTimeSlots=async (selectedBookings)=>{
        let obj = { start: null, end: null, duration: 0 };
        selectedBookings.forEach(slot=>{
            let start = parseISO(slot.start);
            let end = parseISO(slot.end);
            if (obj.start===null || start < obj.start) {
                obj.start = start;
            }
            if (obj.end===null || end > obj.end) {
                obj.end = end;
            }
            obj.duration = differenceInMinutes(obj.end, obj.start);
            return slot;
        });
        return obj;
}

export const handleFormatBooking = async (token, selectedBookings, service, user)=>{
    let adaptedTimeSlot = await adaptTimeSlots(selectedBookings);
    const bookingObject ={
        service_id: service?.id,
        location_id:service?.location_ids[0], 
        user_id: user?.id,
        start_datetime: formatISO(adaptedTimeSlot?.start),
        end_datetime: formatISO(adaptedTimeSlot?.end),
        token_quantity: selectedBookings?.length,
        product_variant_id: token.variant_id
    }
    return bookingObject;
}

export const checkUserTokens = async (id)=>{
    try{
        let response = await Users.tokens ({user_id : id})
        if(response.status === 200 && response.data) return response.data
    }catch(ex){console.error(ex)}
}

/**Used to flip a service booking from pending to confirmed */
export const changeEventStatus= async(eventId)=>{
    try{
        let response = await Events.edit({id: eventId, event_status_id: 2})
        if(!response.status === 200) return "error"
    }catch(ex){
        console.error(ex)
        return "error";
    }
}

export const redeemToken = async(booking, tokenId, last=false)=>{
    console.log(booking)
    let error = "There was an error booking the service"
    try{
        let response = await Pos.payment.token({
            token_id: tokenId,
            event_id: booking.id ,
            user_id: booking.bookingObject.user_id,
        })
        if(response.status===200 && last) {
            let res = await changeEventStatus(booking.id)
            if(res === "error") return error
        }
        else return error;
    }catch(ex){
        console.error(ex)
        return error;
    }
}

export const checkForSerivceBookingOnOrder=async(reduxRegister)=>{
    if(reduxRegister && reduxRegister?.length > 0) {
        let error;
        //user should be the same for all bookings, so just pull the first
        let userTokens = await checkUserTokens(reduxRegister[0].bookingObject.user_id);
        for(let i = 0; i < reduxRegister.length; i++){
            let eachObj = reduxRegister[i]
            let neededTokens = eachObj?.bookingSlots?.length || 0;
            let filteredTokens = userTokens.filter((token)=>token.product_variant_id === eachObj.bookingObject?.product_variant_id)
            if (neededTokens <= filteredTokens?.length){
                for(let j = 0; j < neededTokens; j++){
                    let res = await redeemToken(eachObj, filteredTokens[j].id, j ===  neededTokens-1)
                    if (res) error = res;
                }
            } 
        }
    }else return
}